import React from 'react';
import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '@epoch-ui/lib/utils';
import { Button } from '@epoch-ui/components/Button/button';

const actionButtonIconVariants = cva(
  'tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-[8px]',
  {
    variants: {
      theme: {
        primary: 'tw-bg-brand-tertiary tw-text-primary-blue',
        purple: 'tw-bg-accent-purple-light tw-text-accent-purple',
        success: 'tw-bg-positive tw-text-positive-foreground'
      }
    },
    defaultVariants: {
      theme: 'primary'
    }
  }
);

export const ActionButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      variant="outline"
      type="button"
      className={cn(
        'tw-h-full tw-w-full tw-content-start tw-gap-2 tw-rounded-xl tw-p-2 tw-text-left',
        className
      )}
      {...props}
    />
  );
});

export const ActionButtonIcon = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof actionButtonIconVariants>
>(({ className, theme, ...props }, ref) => {
  return (
    <span ref={ref} className={cn(actionButtonIconVariants({ theme }), className)} {...props} />
  );
});

export const ActionButtonLabel = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn('tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-y-1', className)}
      {...props}
    />
  );
});

export const ActionButtonCaption = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn(
        'tw-block tw-truncate tw-text-xs tw-font-normal tw-text-muted-foreground',
        className
      )}
      {...props}
    />
  );
});
